import {inject, injectable} from "inversify";
import {CountryEnum} from "@/modules/base/enums";
import chance from "@/modules/base/services/chance";
import {Abbreviations, Additions, TeamNamePatternType, TeamNames} from "@/modules/team/resources/team-names";
import {CityType} from "@/modules/team/types";
import CityRepository from "@/modules/team/services/CityRepository";

@injectable()
export default class TeamNameGenerator {
  readonly fallbackCountry: CountryEnum = CountryEnum.GB;

  constructor(
    @inject(CityRepository) private cityRepository: CityRepository,
  ) {
  }

  public generate(options: { country: CountryEnum, city?: CityType }): { long: string, short: string } {
    const item = chance.pickoneByFieldProbability(
      TeamNames[options.country] || TeamNames[CountryEnum.DE]!,
      (item: TeamNamePatternType) => item.level
    );

    const year4 = chance.integer({min: 1880, max: 2000}).toString();
    const year2 = year4.toString().slice(-2);

    const city = options.city
      ? options.city.name
      : chance.pickone(this.cityRepository.getCities(options.country)).name as string;

    const replacements: { [key: string]: string } = {
      '{abbr}': chance.pickone(Abbreviations[options.country] || Abbreviations[this.fallbackCountry]!),
      '{addition}': chance.pickone(Additions[options.country] || Additions[this.fallbackCountry]!!),
      '{city}': city,
      '{cityFirst}': city.charAt(0),
      '{year4}': year4,
      '{year2}': year2,
    };

    let long = item.longPattern;
    let short = item.shortPattern;

    Object.keys(replacements).forEach((k: string) => {
      long = long.replace(k, replacements[k]);
      short = short.replace(k, replacements[k]);
    });

    return {short, long};
  }
}
